import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { State } from 'src/app/models/case/case.interface';
import { PaginatedData, PaginatedDataResponse } from 'src/app/models/common/common.interface';
import { CaseService } from 'src/app/services/case.service';
import { LocationService } from 'src/app/services/location.service';

@Component({
  selector: 'app-subject-detail',
  templateUrl: './subject-detail.component.html',
  styleUrls: ['./subject-detail.component.css'],
})
export class SubjectDetailComponent implements OnInit, OnChanges {
  @Output() formSubmitted: EventEmitter<boolean> = new EventEmitter<boolean>();
  subjectData = [];

  subjectTypes = [
    {
      name: 'Insured',
      value: 'insured',
    },
    {
      name: 'Claimant',
      value: 'claimant',
    },
    {
      name: 'Defense Attorney',
      value: 'defense_attorney',
    },
    {
      name: 'Applicant/Party Attorney',
      value: 'applicant_party_attorney',
    },
    {
      name: 'Co-defendant',
      value: 'co_defendant',
    },
    {
      name: 'Other',
      value: 'other',
    },
  ];

  selectedSubjectType = new FormControl('insured');
  insuredForm: FormGroup;
  claimantForm: FormGroup;
  defenseAttorneyApplicantForm: FormGroup;
  coDefendantForm: FormGroup;
  otherForm: FormGroup;
  @Input() editSubjectIndex = null;
  @Input() subject = null;
  states$: Observable<State[]>;
  unsubscribe$ = new Subject<void>();

  constructor(
    protected fb: FormBuilder,
    private caseService: CaseService,
    private locationService: LocationService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.initInsuredForm();
    this.states$ = this.states();
    this.subjectData = this.caseService.caseDataValue.subject_detail || [];

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['subject'] && changes['subject']?.currentValue) {
      this.prefillSubjectForm(changes['subject']?.currentValue);
      this.editSubjectIndex = changes['editSubjectIndex']?.currentValue;
    }

  }

  prefillSubjectForm(subject) {
    this.selectedSubjectType.setValue(subject?.type);
    this.onChangeSubjectType();

    switch (subject?.type) {
      case 'insured':
        this.insuredForm.patchValue(subject);
        break;
      case 'claimant':
        this.claimantForm.patchValue(subject);
        break;
      case 'defense_attorney':
      case 'applicant_party_attorney':
      this.defenseAttorneyApplicantForm.patchValue(subject);
        break;
      case 'co_defendant':
        this.coDefendantForm.patchValue(subject);
        break;
      case 'other':
        this.otherForm.patchValue(subject);
        break;
      default:
        break;
    }
  }

  getSubjectDataByType(type) {
    return this.subjectData.filter((subject) => subject.type === type);
  }

  onSubmitForm() {
    // if(this.saveSubject(true) === false){
    //   return;
    // }

    const caseId = this.caseService.caseDataValue?.saved_case_data?.case.id;
    const reqBody = {
      insureds: this.getSubjectDataByType('insured'),
      claimants: this.getSubjectDataByType('claimant'),
      defense_attorneys: this.getSubjectDataByType('defense_attorney'),
      applicant_attorneys: this.getSubjectDataByType('applicant_party_attorney'),
      co_defendants: this.getSubjectDataByType('co_defendant'),
      others: this.getSubjectDataByType('other'),
    }
    console.log("🚀 ~ SubjectDetailComponent ~ onSubmitForm ~ reqBody:", reqBody)

    this.caseService.createCaseSubjectInformation(caseId,reqBody)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(
      (res) => {
        this.toastr.success(res?.details?.message);
        this.formSubmitted.emit(true);
        this.caseService.setCaseData({
          ...this.caseService.caseDataValue,
          saved_case_data: res?.details?.data,
        });
      },
      ({ error }: HttpErrorResponse) => {
        this.toastr.error(error?.errors[0]);
      }
    );
  }

  addNewSubject() {
    this.selectedSubjectType.setValue('');
    this.editSubjectIndex = null;
    this.subject = null;
  }

  saveSubject(isSubmit = false) {
    let form: FormGroup = null;
    switch (this.selectedSubjectType.value) {
      case 'insured':
        form = this.insuredForm;
        break;
      case 'claimant':
        form = this.claimantForm;
        break;

      case 'defense_attorney':
        form = this.defenseAttorneyApplicantForm;
        break;

      case 'applicant_party_attorney':
        form = this.defenseAttorneyApplicantForm;
        break;
      case 'co_defendant':
        form = this.coDefendantForm;
        break;
      case 'other':
        form = this.otherForm;
        break;

      default:
        break;
    }


    if(form.invalid){
      form.markAllAsTouched();
      return false;
    }

    if(this.editSubjectIndex !== null && this.editSubjectIndex !== undefined){
      this.subjectData[this.editSubjectIndex] = form.value;
    }else{
      this.subjectData.push(form.value);
    }

    this.caseService.setCaseData({
      ...this.caseService.caseDataValue,
      subject_detail: this.subjectData,
    });

    if(!isSubmit){
      form.reset();
      this.editSubjectIndex = null;
      this.subject = null;
    }


  }

  onChangeSubjectType() {
    switch (this.selectedSubjectType.value) {
      case 'insured':
        this.initInsuredForm();
        break;
      case 'claimant':
        this.initClaimantForm();
        break;

      case 'defense_attorney':
        this.initDefenseAttorneyApplicantForm('defense_attorney');
        break;

      case 'applicant_party_attorney':
        this.initDefenseAttorneyApplicantForm('applicant_party_attorney');
        break;
      case 'co_defendant':
        this.initCoDefendantForm();
        break;
      case 'other':
        this.initOtherForm();
        break;

      default:
        break;
    }
  }

  initInsuredForm() {
    this.insuredForm = this.fb.group({
      type: new FormControl('insured'),
      business_name: new FormControl(''),
      first_name: new FormControl('', [Validators.required]),
      middle_name: new FormControl(''),
      last_name: new FormControl(''),
      aka: new FormControl(''),
      dob: new FormControl(''),
      ssn: new FormControl(''),
      address_1: new FormControl(''),
      city: new FormControl(''),
      state: new FormControl(''),
      zip: new FormControl(''),
      email: new FormControl(''),
      main_phone_number: new FormControl(''),
      cell_phone_number: new FormControl(''),
      suffix : new FormControl(''),
    });
  }

  initClaimantForm() {
    this.claimantForm = this.fb.group({
      type: new FormControl('claimant'),
      first_name: new FormControl('', [Validators.required]),
      middle_name: new FormControl(''),
      last_name: new FormControl(''),
      suffix: new FormControl(''),
      aka: new FormControl(''),
      dob: new FormControl(''),
      address_1: new FormControl(''),
      city: new FormControl(''),
      state: new FormControl(''),
      zip: new FormControl(''),
      email: new FormControl(''),
      home_phone_number: new FormControl(''),
      cell_phone_number: new FormControl(''),
      business_phone_number: new FormControl(''),
      ssn: new FormControl(''),
    });
  }

  initDefenseAttorneyApplicantForm(type) {
    this.defenseAttorneyApplicantForm = this.fb.group({
      type: new FormControl(type),
      firm_name: new FormControl(''),
      first_name: new FormControl('', [Validators.required]),
      middle_name: new FormControl(''),
      last_name: new FormControl(''),
      suffix: new FormControl(''),
      aka: new FormControl(''),
      ssn: new FormControl(''),
      address_1: new FormControl(''),
      city: new FormControl(''),
      state: new FormControl(''),
      zip: new FormControl(''),
      email: new FormControl(''),
      cell_phone_number: new FormControl(''),
      business_phone_number: new FormControl(''),
    });
  }

  initCoDefendantForm() {
    this.coDefendantForm = this.fb.group({
      type: new FormControl('co_defendant'),
      company_name: new FormControl(''),
      first_name: new FormControl('', [Validators.required]),
      middle_name: new FormControl(''),
      last_name: new FormControl(''),
      role: new FormControl(''),
      suffix: new FormControl(''),
      aka: new FormControl(''),
      address_1: new FormControl(''),
      city: new FormControl(''),
      state: new FormControl(''),
      zip: new FormControl(''),
      email: new FormControl(''),
      home_phone_number: new FormControl(''),
      cell_phone_number: new FormControl(''),
      business_phone_number: new FormControl(''),
    });
  }

  initOtherForm() {
    this.otherForm = this.fb.group({
      type: new FormControl('other'),
      company_name: new FormControl(''),
      first_name: new FormControl('', [Validators.required]),
      middle_name: new FormControl(''),
      last_name: new FormControl(''),
      role: new FormControl(''),
      suffix: new FormControl(''),
      aka: new FormControl(''),
      address_1: new FormControl(''),
      city: new FormControl(''),
      state: new FormControl(''),
      zip: new FormControl(''),
      email: new FormControl(''),
      home_phone_number: new FormControl(''),
      cell_phone_number: new FormControl(''),
      business_phone_number: new FormControl(''),
      ssn: new FormControl(''),
      dob: new FormControl(''),
    });
  }

  states = () : Observable<State[]> => {
    return this.locationService
      .getStates(
        10,
        1
      )
      .pipe(
        map(
          (res: PaginatedDataResponse<PaginatedData<State>>) =>
            res?.details?.hits || []
        )
      );
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
